module.exports = __webpack_public_path__ + "img/IPKO.1069e07e.png";